<template>
  <!---全体を囲む--->
  <div class="content-wrapper">
    <!-- ログインしてください -->
    <FacePhraseForIndexPage v-if="!isLogin" phrase="ログインしてください" />

    <!-- BookGroupの一覧 -->
    <TemplateMyTicketsIndexOfPast v-else-if="isReadyToDraw" />

    <!-- index画面の描画ローディング -->
    <ItemDialogForIndexPage v-else />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import TemplateMyTicketsIndexOfPast from "@/views/Templates/MyTickets/TemplateMyTicketsIndexOfPast";

// API
import API from "@/API";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "MyTicketsIndexOfPast",
  components: {
    TemplateMyTicketsIndexOfPast: TemplateMyTicketsIndexOfPast,
  },

  setup() {
    const store = useStore();

    const isLogin = store.getters["common/isLogin"];
    const isReadyToDraw = ref(false);

    onMounted(async () => {
      if (!isLogin) {
        // 未ログイン時はネイティブでダイアログ
        nativeHandlerService.returnNativeAppToAccountPage();
      } else {
        try {
          await Promise.all([
            // Myチケット取得(使用済み)
            API.getMytickets(true, false),
            // 特急券取得(使用済み isPast:true)
            API.getMyLimitedExpressTickets(true),
            // 特急券の引換券取得(isNotRecall: true)
            API.getMyCoupons(true),
            // シェアサイクル利用履歴取得
            API.getDbsReportsForPast(true),
          ]);
        } catch (e) {
          console.log("Error in MyTicketsIndexOfPast ", e);
        }
      }
    });

    const bookGroups = computed(() => store.getters["ticketing/bookGroups"]);
    const myLimitedExpressTickets = computed(
      () => store.getters["MFITT/myLimitedExpressTickets"]
    );

    watchEffect(() => {
      if (
        bookGroups.value &&
        bookGroups.value.length >= 0 &&
        myLimitedExpressTickets.value
      ) {
        isReadyToDraw.value = true;
      }
    });

    return {
      isLogin,
      isReadyToDraw,
    };
  },
};
</script>
